/**
 * Extract a user-facing error message from an axios-style error envelope.
 * Returns `undefined` when the shape doesn't match so callers can fall back
 * to a localized default.
 */
export function extractBackendMessage(error: unknown): string | undefined {
  if (!error || typeof error !== 'object') return undefined;
  const response = (error as { response?: unknown }).response;
  if (!response || typeof response !== 'object') return undefined;
  const data = (response as { data?: unknown }).data;
  // A BARE JSON STRING BODY is a message, not "no message": the status-board writes
  // (`sync-update`, `set-preset`, `pull-preset`) refuse a cited task with exactly
  // that shape — `"<Task name>" is referenced by … and cannot be deleted`.
  if (typeof data === 'string') return data.trim() ? data : undefined;
  if (!data || typeof data !== 'object') return undefined;
  const message = (data as { message?: unknown }).message;
  return typeof message === 'string' ? message : undefined;
}
